import React, { useState } from 'react';
import { getToken } from '../utils/storage';
import axios from 'axios';
import { toast } from 'sonner';
import { HelpCircle, CheckCircle } from 'lucide-react';
import CustomerLayout from '../components/CustomerLayout';
import { useTranslation } from 'react-i18next';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CustomerSupport = () => {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    organization: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = getToken();
      
      // Convert to FormData for backend
      const submitData = new FormData();
      submitData.append('name', formData.name);
      submitData.append('organization', formData.organization);
      submitData.append('email', formData.email);
      submitData.append('phone', formData.phone);
      submitData.append('message', formData.message);
      
      await axios.post(`${API}/support/contact`, submitData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setSubmitted(true);
      toast.success(t('customerSupport.requestSent'));
      
      // Reset form
      setFormData({
        name: '',
        organization: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending support request:', error);
      const errorMessage = error.response?.data?.detail || t('customerSupport.errorSending');
      toast.error(errorMessage);
    }
  };

  if (submitted) {
    return (
      <CustomerLayout>
        <div className="page-container">
          <div style={{
            maxWidth: '600px',
            margin: '4rem auto',
            textAlign: 'center'
          }}>
            <div style={{
              background: 'rgba(80, 227, 194, 0.1)',
              padding: '3rem 2rem',
              borderRadius: '12px',
              border: '2px solid rgba(80, 227, 194, 0.3)'
            }}>
              <CheckCircle size={64} color="#50E3C2" style={{ margin: '0 auto 1.5rem' }} />
              <h1 style={{ color: '#50E3C2', marginBottom: '1rem' }}>
                {t('customerSupport.thankYou')}
              </h1>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '2rem', opacity: 0.9, color: '#FFFFFF' }}>
                {t('customerSupport.receivedMessage')}
              </p>
              <button
                className="btn btn-primary"
                onClick={() => setSubmitted(false)}
              >
                {t('customerSupport.sendAnother')}
              </button>
            </div>
          </div>
        </div>
      </CustomerLayout>
    );
  }

  return (
    <CustomerLayout>
      <div className="page-container">
        <div className="page-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <HelpCircle size={32} color="#50E3C2" />
            <h1 style={{ color: '#FFFFFF' }}>{t('customerSupport.title')}</h1>
          </div>
        </div>

        <div className="card" style={{ maxWidth: '800px', margin: '0 auto' }}>
          <p style={{ marginBottom: '2rem', fontSize: '1.05rem', lineHeight: '1.6', color: '#FFFFFF' }}>
            {t('customerSupport.description')}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label style={{ color: '#FFFFFF' }}>{t('customerSupport.formName')}</label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                placeholder={t('customerSupport.namePlaceholder')}
                required
                style={{ color: '#FFFFFF' }}
              />
            </div>

            <div className="form-group">
              <label style={{ color: '#FFFFFF' }}>{t('customerSupport.formOrganization')}</label>
              <input
                type="text"
                value={formData.organization}
                onChange={(e) => setFormData({...formData, organization: e.target.value})}
                placeholder={t('customerSupport.organizationPlaceholder')}
                required
                style={{ color: '#FFFFFF' }}
              />
            </div>

            <div className="form-group">
              <label style={{ color: '#FFFFFF' }}>{t('customerSupport.formEmail')}</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                placeholder={t('customerSupport.emailPlaceholder')}
                required
                style={{ color: '#FFFFFF' }}
              />
            </div>

            <div className="form-group">
              <label style={{ color: '#FFFFFF' }}>{t('customerSupport.formPhone')}</label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                placeholder={t('customerSupport.phonePlaceholder')}
                required
                style={{ color: '#FFFFFF' }}
              />
            </div>

            <div className="form-group">
              <label style={{ color: '#FFFFFF' }}>{t('customerSupport.formMessage')}</label>
              <textarea
                value={formData.message}
                onChange={(e) => setFormData({...formData, message: e.target.value})}
                rows={8}
                placeholder={t('customerSupport.messagePlaceholder')}
                required
                style={{ color: '#FFFFFF' }}
              />
            </div>

            <div style={{
              background: 'rgba(80, 227, 194, 0.05)',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1.5rem',
              fontSize: '0.9rem',
              color: '#FFFFFF',
              opacity: 0.9
            }}>
              💡 {t('customerSupport.tip')}
            </div>

            <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
              {t('customerSupport.sendRequest')}
            </button>
          </form>
        </div>
      </div>
    </CustomerLayout>
  );
};

export default CustomerSupport;
